module.exports = __webpack_public_path__ + "img/success.84da4b4a.png";